import { render, staticRenderFns } from "./VCheckboxes.vue?vue&type=template&id=69b55af6"
import script from "./VCheckboxes.vue?vue&type=script&lang=js"
export * from "./VCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports